// extracted by mini-css-extract-plugin
export default {"customRow":"MicrofloraCard_customRow__ATEXl"};